// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chargingMainDiv_Kratos .btn-primary{
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  }
  .chargingMainDiv_Kratos .btn-outline-primary{
    border-color: #83A4CF !important;
    color: #83A4CF !important;
  }
  .chargingMainDiv_Kratos .ev_filter_icon {
    background: #fff !important;
    color: #83A4CF !important;
  }
  
  /* imp code commented */
  /* .chargingMainDiv_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  } */
  /* imp code commented */
  
  /*********************** Slow Button *************************/
  .kpiSlowBTN_Kratos .btn-outline-primary{
    /* color:#83A4CF; */
    border-color:#83A4CF !important;
  }
  .kpiSlowBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
    box-shadow: none;
  }
  .kpiSlowBTN_Kratos .btn-outline-primary {
    --bs-btn-color: #83A4CF !important;
    --bs-btn-border-color: #83A4CF !important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #83A4CF !important;
    --bs-btn-hover-border-color: #83A4CF !important;
    --bs-btn-focus-shadow-rgb: 13,110,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #83A4CF !important;
    --bs-btn-active-border-color: #83A4CF !important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #83A4CF !important;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #83A4CF !important;
    --bs-gradient: none;
  }
  
  .kpiSlowBTN_Kratos .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {
    /* color: #fff; */
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
    }
    .kpiSlowBTN_Kratos .ev_SButton {
      background: none !important;
      color: #7b7878 !important;
      border-color: #7b7878 !important;
    }
  
  /* imp code commented */
  /* .kpiSlowBTN_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  } */
  /* imp code commented */
  
  .kpiSlowBTN_Kratos .btn-outline-primary:hover{
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  }
  /*********************** Slow Button Ends *************************/
  
  
  /*********************** Fast Button *************************/
  .kpiFastBTN_Kratos .btn-outline-warning{
    /* color:#3578b0; */
    /* border-color:#3578b0 !important; */
  }
  .kpiFastBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
    box-shadow: none;
  }
  .kpiFastBTN_Kratos .btn-outline-warning {
    --bs-btn-color: #3578b0 !important;
    --bs-btn-border-color: #3578b0 !important;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #3578b0 !important;
    --bs-btn-hover-border-color: #3578b0 !important;
    --bs-btn-focus-shadow-rgb: 255,193,7;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #3578b0 !important;
    --bs-btn-active-border-color: #3578b0 !important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #3578b0 !important;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #3578b0 !important;
    --bs-gradient: none;
  }
  
  .kpiFastBTN_Kratos .ev_FButton {
    background: none !important;
    /* color: #3578b0 !important; */
    /* background: #7b7878 !important; */
    /* border: #7b7878; */
    border-color: #7b7878;
  }
  
  /* imp code commented */
  /* .kpiFastBTN_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #3578b0;
    border-color: #3578b0;
  } */
  /* imp code commented */
  /*********************** Fast Button Ends *************************/
  
  .bg-white{
      background-color:#fff;
  }
  
  .chargingMainDiv_Kratos{
      /* margin-top:80px; */
    margin-top: 15px;
  }
  
  .chargingWidget_Kratos{
      /* background: #fff; */
      box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
      border-radius: 5px;
    background: #CDDAEA;
  }
  .chargingWidgetIcon_Kratos img{
      width:50px;
      height:50px;
  }
  .chargingWidgetIcon1_Kratos img{
      width:35px;
      height:35px;
  }
  .chargingWidgetIcon_Kratos-32_Kratos img{
      width:32px;height:32px;
  }
  .chargingTitleBg_Kratos {
    /* font-size: 1em;
    color: #0E3157;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
      border-radius: 5px 5px 0 0; */
  
    font-size: 1em;
    color: #0E3157;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
    background: #E0E0E0;
    border-radius: 5px 5px 0 0;
    /* margin-top: -12px;
    margin-left: -10px;
    margin-right: -10px; */
  }
  /* .chargingTitleChart_Bus {
      font-size: 0.9em;
      color: #0E3157;
      font-weight: 600;
      margin-bottom: 5px;
      text-align: left;
      background: #E0E0E0;
        border-radius: 5px 5px 0 0;
      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  } */
  
  .chargingTitleChart_Kratos_fleet {
      font-size: 0.9em;
      color: #0E3157;
      /* color: #353535; */
      font-weight: 600;
      margin-bottom: 5px;
      text-align: left;
      background: #E0E0E0;
        border-radius: 5px 5px 0 0;
      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  }
  
  
  /* .secondtable {
    border-collapse: collapse;
    width: 100%;
  } */
  .secondtable {
    border-collapse: separate; /* Change from collapse to separate */
    border-spacing: 0; /* Ensure no spacing between borders */
    width: 100%;
    border-radius: 5px; /* Add border radius to the table */
    overflow: hidden; /* Ensure the corners are rounded */
    border: 1px solid #46484b; /* Add a border to the table */
  }
  
  .secondtable th, .secondtable td {
    /* border: 1px solid #ddd; */
    border: 1px solid #46484b;
    /* border-radius: 3px solid #46484b; */
    padding: 8px;
    text-align: center;
  }
  
  .secondtable th {
    background-color: #83A4CF;
    color: #fff;
    font-size: 13px;
  }
  
  /* .secondtable tbody tr:nth-child(even) {
    background-color: #f2f2f2;
  } */
  
  /* Add lines after each column */
  .secondtable th:not(:last-child), .secondtable td:not(:last-child) {
    /* border-right: 1px solid #ddd; */
    border-right: 1px solid #46484b;
  }
  
  
  .chargingChartbox_Kratos{
      /* background: #FFFFFF;
      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
      color: #353535;
      min-height: 280px;
      border-radius: 5px; */
    background: #FFFFFF;
    padding: 0px;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  }
  
  .wd_Kratos{
      min-height: 330px !important;
  }
  .wd_4_charts_Kratos{
      min-height: 307px !important;
    }
  .highlightBoxKpi_Kratos{
      /* min-height: 310px !important; */
  }
  .highlightTableSec_Kratos{
      min-height: 310px !important;
  }
  .chargingChartHGT_Kratos{
      padding: 10px;
  }
  
  .chargingH5_Kratos .h5 {
      font-size: 1rem !important;
      /* font-size: 1.1rem !important; */
  }
  .chargingKpiSmallTxt_Kratos{
      font-size: 77% !important;
      line-height: 1em !important;
  }
  
  .tableContent_Kratos table tr td {
      font-size:0.8em;
  }
  
  .chargingFilterForm_Kratos > .form-label{
      font-size:0.825em;
  }
  
  .chargingHeadfont_Kratos{
      font-size:1.8rem;
  }
  .topRightDropMenu_Kratos .dropdown-menu[data-bs-popper] {
      right:0 !important;
      left: auto;
  }
  
  /********************  *********************/
  
  .contentScroll_Kratos{
      /* overflow-y: scroll; */
      /* height:150px; */
  }
  
  .chargingWidget_Kratos p {
      line-height: 1rem !important;
  }
  .chargingWidget_Kratos p small{
      font-size:80% !important;
  }
  
  /***************************** Toggle Switch ***************************/
  .toggleBtn_Kratos .form-switch .form-check-input:checked:before {
      content: "C";
      position: absolute;
      width: 20px;
      height: 10px;
      padding-left: 20px;
      margin-top: -1px;
      font-size: 0.7em;
  }
  .toggleBtn_Kratos .form-switch .form-check-input:before{
      content: "V";
      position: absolute;
      width: 20px;
      height: 10px;
      padding-left: 5px;
      margin-top: -1px;
      font-size: 0.7em;
  }
  .toggleBtn_Kratos .form-switch .form-check-input{
      color:#83A4CF !important;
  }
  
  /* k */
  .toggleBtn_Kratos .toggle-button-cover {
    position: relative;
    top: 8px;
  }
  .dropdownSelectBtnCharging_Kratos{
      width: fit-content;
  }
  .toggleBtn_Kratos .button-cover {
    background-color: #fff;
    box-shadow: 0 10px 20px -8px #c5d6d6;
    border-radius: 4px;
  }
  
  .toggleBtn_Kratos .button-cover:before {
    color: #d7e3e3;
    font-size: 12px;
    line-height: 1;
    padding: 5px;
  }
  
  .toggleBtn_Kratos .button-cover,
  .knobs,
  .layer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  .toggleBtn_Kratos .buttonbtn {
    position: relative;
    top: 50%;
    width: 50px;
  }
  
  .toggleBtn_Kratos .buttonbtn.r,
  .buttonbtn.r .layer {
    border-radius: 100px;
  }
  
  .toggleBtn_Kratos .button.b2 {
    border-radius: 2px;
  }
  
  .toggleBtn_Kratos .checkbox {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }
  
  .toggleBtn_Kratos .knobs {
    z-index: 2;
  }
  
  .toggleBtn_Kratos .layer {
    width: 100%;
    background-color: #ebf7fc;
    transition: 0.3s ease all;
    z-index: 1;
  }
  /* Button 1 */
  #button-1_Kratos .knobs:before {
    content: "V";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 20px;
    height: 20px;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 6px 4px;
    background-color: #83A4CF;
    border-radius: 50%;
    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
  }
  
  #button-1_Kratos .checkbox:checked + .knobs:before {
    content: "C";
    left: 30px;
    background-color: #3578b0;
  }
  
  #button-1_Kratos .checkbox:checked ~ .layer {
    /* fent orange change */
    /* background-color: #fcebeb; */
    background-color: #94c1e6;
  }
  
  #button-1_Kratos .knobs,
  #button-1_Kratos .knobs:before,
  #button-1_Kratos .layer {
    transition: 0.3s ease all;
  }
  
  /***************************** PageTwo *******************************/
  
  /*************************  *****************************/
  .kpiNotificationSlow_Kratos{
      color: #83A4CF;
      font-size: 0.7em;
      font-weight: 500;
  }
  .kpiNotificationFast_Kratos{
      color:#3578b0;
      font-size:0.7em;
      font-weight:500;
  }
  
  .kpiNotificationBoth_Kratos{
      color:#72D817;
      font-size:0.7em;
      font-weight:500;
  }
  /* media queries start here */
  
  @media (min-width: 1440px) {
  .col205{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  @media (max-width: 1440px) {
  .highlightTableSec_Kratos{
      min-height: 310px !important;
  }
  }
  
  @media (min-width: 1336px) {
  .col205{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  
  @media (max-width: 1024px) {
  .highlightTableSec_Kratos{
      min-height: 330px !important;
  }
  }
  
  
  @media (min-width: 992px) {
  .col205{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  
  @media (min-width: 836px) {
  /* .navbar-expand-sm { */
      /* flex-wrap: nowrap !important; */
      /* justify-content: flex-start !important; */
  /* } */
  }
  
  @media screen and (max-width: 740px) {
  .chargingTitleBg_Kratos {
      font-size: 0.9em;
  }
  }
  
  
  @media screen and (max-width: 720px) {
  /* .chargingMainDiv_Bus{ */
      /* margin-top:124px; */
  /* } */
  }
  
  @media screen and (max-width: 480px) {
  /* .chargingMainDiv_Bus{ */
      /* margin-top:155px; */
  /* } */
  }
      
  @media screen and (max-width: 480px) {
  
  .chargingHeadfont_Kratos {
      font-size: 1rem;
  }
  .chargingTitleBg_Kratos {
      font-size: 0.9em;
  }
  }
  
  @media screen and (max-width: 320px) {
  
  }
  
  .highlight_five_Kratos{
    margin: auto;
  }
  
  .text_bottom_Kratos{
    margin-bottom: '-16px !important';
    display: none;
    z-index: 1;
  }
  .btn-infotable_Kratos:active {
    color: black;
    background-color: #fff;
    border-color: #32879c; 
  }
  
  /* .col-19 {
    flex: 0 0 calc(100% / 19);
    max-width: calc(100% / 19);
  } */
  
  @media (min-width: 1440px) {
    .col-19 {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  @media (min-width: 1336px) {
    .col-19 {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  @media (min-width: 992px) {
    .col-19 {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  
  /* @media (max-width: 576px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 576px) and (max-width: 768px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 768px) and (max-width: 992px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 992px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  } */
  
  .main_hole_background{
    background-color: #F2F3FC;
    /* height: 530px; */
    /* min-height: 90vh; 
    display: flex;
    flex-direction: column; */
  }
  
  .chargingChartboxNew_Kratos {
    background: #FFFFFF;
    padding: 0px;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    height: 293px;
    /* height: 333px; */
    border-radius: 5px 5px 0 0;
  }
  .chargingChartboxNew2_Kratos {
    background: #FFFFFF;
    padding: 0px;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    /* height: 293px; */
    height: 313px;
    border-radius: 5px 5px 0 0;
  }
  
  .highBold {
    font-weight: bold;
    color: black;
    font-size:16px !important
  }
  
  .filter_kratos_icon_f .rca_btn .rca_btn_kratos  {
    background-color: #ffa650;
  }
  .filter_kratos_icon_f .rca_btn .rca_btn_kratos:hover{
    background-color: #fcb877 !important; 
    border-color: #fcb877 !important;
  }
  
  .popUpTable{
    background-color: rgb(131, 164, 207);
    color: rgb(255, 255, 255);
    position: sticky;
    top: 0;
    z-index: 0;
  }
  
  .custom-table .p-datatable-thead th {
    background-color: #83A4CF;
    /* Set your desired background color */
    color: white;
    /* Set your desired text color */
  }
  
  /* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */
  .custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {
    color: white;
    height: 20px!important;
    width: 12px!important;
    /* Set your desired arrow color */
  }
  
  .even-row {
    background-color: pink;
  }
  
  .odd-row {
    background-color: white;
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/CriticalVehicle_Kratos_Fleet/CriticalCustom_Kratos_fleet.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;;EAEvB,8DAA8D;EAC9D;IACE,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yCAAyC;IACzC,0BAA0B;IAC1B,qCAAqC;IACrC,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,sCAAsC;IACtC,gDAAgD;IAChD,4DAA4D;IAC5D,2CAA2C;IAC3C,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,gCAAgC;IAChC;IACA;MACE,2BAA2B;MAC3B,yBAAyB;MACzB,gCAAgC;IAClC;;EAEF,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;;EAEvB;IACE,oCAAoC;IACpC,gCAAgC;EAClC;EACA,mEAAmE;;;EAGnE,8DAA8D;EAC9D;IACE,mBAAmB;IACnB,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yCAAyC;IACzC,0BAA0B;IAC1B,qCAAqC;IACrC,+CAA+C;IAC/C,oCAAoC;IACpC,2BAA2B;IAC3B,sCAAsC;IACtC,gDAAgD;IAChD,4DAA4D;IAC5D,2CAA2C;IAC3C,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;IAC/B,oCAAoC;IACpC,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;EACvB,mEAAmE;;EAEnE;MACI,qBAAqB;EACzB;;EAEA;MACI,qBAAqB;IACvB,gBAAgB;EAClB;;EAEA;MACI,sBAAsB;MACtB,4CAA4C;MAC5C,kBAAkB;IACpB,mBAAmB;EACrB;EACA;MACI,UAAU;MACV,WAAW;EACf;EACA;MACI,UAAU;MACV,WAAW;EACf;EACA;MACI,UAAU,CAAC,WAAW;EAC1B;EACA;IACE;;;;;;mCAM+B;;IAE/B,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B;;0BAEsB;EACxB;EACA;;;;;;;;;KASG;;EAEH;MACI,gBAAgB;MAChB,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;QACjB,0BAA0B;MAC5B,wCAAwC;EAC5C;;;EAGA;;;KAGG;EACH;IACE,yBAAyB,EAAE,qCAAqC;IAChE,iBAAiB,EAAE,sCAAsC;IACzD,WAAW;IACX,kBAAkB,EAAE,mCAAmC;IACvD,gBAAgB,EAAE,mCAAmC;IACrD,yBAAyB,EAAE,8BAA8B;EAC3D;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;IACzB,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;;KAEG;;EAEH,gCAAgC;EAChC;IACE,kCAAkC;IAClC,+BAA+B;EACjC;;;EAGA;MACI;;;;2BAIqB;IACvB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;MACI,4BAA4B;EAChC;EACA;MACI,4BAA4B;IAC9B;EACF;MACI,kCAAkC;EACtC;EACA;MACI,4BAA4B;EAChC;EACA;MACI,aAAa;EACjB;;EAEA;MACI,0BAA0B;MAC1B,kCAAkC;EACtC;EACA;MACI,yBAAyB;MACzB,2BAA2B;EAC/B;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,gBAAgB;EACpB;EACA;MACI,kBAAkB;MAClB,UAAU;EACd;;EAEA,4CAA4C;;EAE5C;MACI,wBAAwB;MACxB,kBAAkB;EACtB;;EAEA;MACI,4BAA4B;EAChC;EACA;MACI,wBAAwB;EAC5B;;EAEA,wEAAwE;EACxE;MACI,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,wBAAwB;EAC5B;;EAEA,MAAM;EACN;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;MACI,kBAAkB;EACtB;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;EACZ;EACA,aAAa;EACb;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yDAAyD;EAC3D;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA,sEAAsE;;EAEtE,yDAAyD;EACzD;MACI,cAAc;MACd,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,aAAa;MACb,eAAe;MACf,eAAe;EACnB;;EAEA;MACI,aAAa;MACb,eAAe;MACf,eAAe;EACnB;EACA,6BAA6B;;EAE7B;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;EAEA;EACA;MACI,4BAA4B;EAChC;EACA;;EAEA;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;;EAGA;EACA;MACI,4BAA4B;EAChC;EACA;;;EAGA;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;;EAGA;EACA,wBAAwB;MACpB,kCAAkC;MAClC,4CAA4C;EAChD,MAAM;EACN;;EAEA;EACA;MACI,gBAAgB;EACpB;EACA;;;EAGA;EACA,0BAA0B;MACtB,sBAAsB;EAC1B,MAAM;EACN;;EAEA;EACA,0BAA0B;MACtB,sBAAsB;EAC1B,MAAM;EACN;;EAEA;;EAEA;MACI,eAAe;EACnB;EACA;MACI,gBAAgB;EACpB;EACA;;EAEA;;EAEA;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,aAAa;IACb,UAAU;EACZ;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;;;KAGG;;EAEH;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;EAEA;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;EAEA;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;;EAGA;;;;;;;;;;;;;;;;;;;;;;;;;;KA0BG;;EAEH;IACE,yBAAyB;IACzB,mBAAmB;IACnB;;6BAEyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ;EACF;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,YAAY;IACZ,gCAAgC;EAClC;;EAEA,uFAAuF;EACvF;IACE,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB","sourcesContent":[".chargingMainDiv_Kratos .btn-primary{\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  }\n  .chargingMainDiv_Kratos .btn-outline-primary{\n    border-color: #83A4CF !important;\n    color: #83A4CF !important;\n  }\n  .chargingMainDiv_Kratos .ev_filter_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n  }\n  \n  /* imp code commented */\n  /* .chargingMainDiv_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  } */\n  /* imp code commented */\n  \n  /*********************** Slow Button *************************/\n  .kpiSlowBTN_Kratos .btn-outline-primary{\n    /* color:#83A4CF; */\n    border-color:#83A4CF !important;\n  }\n  .kpiSlowBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n    box-shadow: none;\n  }\n  .kpiSlowBTN_Kratos .btn-outline-primary {\n    --bs-btn-color: #83A4CF !important;\n    --bs-btn-border-color: #83A4CF !important;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #83A4CF !important;\n    --bs-btn-hover-border-color: #83A4CF !important;\n    --bs-btn-focus-shadow-rgb: 13,110,253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #83A4CF !important;\n    --bs-btn-active-border-color: #83A4CF !important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #83A4CF !important;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #83A4CF !important;\n    --bs-gradient: none;\n  }\n  \n  .kpiSlowBTN_Kratos .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {\n    /* color: #fff; */\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n    }\n    .kpiSlowBTN_Kratos .ev_SButton {\n      background: none !important;\n      color: #7b7878 !important;\n      border-color: #7b7878 !important;\n    }\n  \n  /* imp code commented */\n  /* .kpiSlowBTN_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  } */\n  /* imp code commented */\n  \n  .kpiSlowBTN_Kratos .btn-outline-primary:hover{\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  }\n  /*********************** Slow Button Ends *************************/\n  \n  \n  /*********************** Fast Button *************************/\n  .kpiFastBTN_Kratos .btn-outline-warning{\n    /* color:#3578b0; */\n    /* border-color:#3578b0 !important; */\n  }\n  .kpiFastBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n    box-shadow: none;\n  }\n  .kpiFastBTN_Kratos .btn-outline-warning {\n    --bs-btn-color: #3578b0 !important;\n    --bs-btn-border-color: #3578b0 !important;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #3578b0 !important;\n    --bs-btn-hover-border-color: #3578b0 !important;\n    --bs-btn-focus-shadow-rgb: 255,193,7;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #3578b0 !important;\n    --bs-btn-active-border-color: #3578b0 !important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #3578b0 !important;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #3578b0 !important;\n    --bs-gradient: none;\n  }\n  \n  .kpiFastBTN_Kratos .ev_FButton {\n    background: none !important;\n    /* color: #3578b0 !important; */\n    /* background: #7b7878 !important; */\n    /* border: #7b7878; */\n    border-color: #7b7878;\n  }\n  \n  /* imp code commented */\n  /* .kpiFastBTN_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #3578b0;\n    border-color: #3578b0;\n  } */\n  /* imp code commented */\n  /*********************** Fast Button Ends *************************/\n  \n  .bg-white{\n      background-color:#fff;\n  }\n  \n  .chargingMainDiv_Kratos{\n      /* margin-top:80px; */\n    margin-top: 15px;\n  }\n  \n  .chargingWidget_Kratos{\n      /* background: #fff; */\n      box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n      border-radius: 5px;\n    background: #CDDAEA;\n  }\n  .chargingWidgetIcon_Kratos img{\n      width:50px;\n      height:50px;\n  }\n  .chargingWidgetIcon1_Kratos img{\n      width:35px;\n      height:35px;\n  }\n  .chargingWidgetIcon_Kratos-32_Kratos img{\n      width:32px;height:32px;\n  }\n  .chargingTitleBg_Kratos {\n    /* font-size: 1em;\n    color: #0E3157;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n      border-radius: 5px 5px 0 0; */\n  \n    font-size: 1em;\n    color: #0E3157;\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-align: center;\n    background: #E0E0E0;\n    border-radius: 5px 5px 0 0;\n    /* margin-top: -12px;\n    margin-left: -10px;\n    margin-right: -10px; */\n  }\n  /* .chargingTitleChart_Bus {\n      font-size: 0.9em;\n      color: #0E3157;\n      font-weight: 600;\n      margin-bottom: 5px;\n      text-align: left;\n      background: #E0E0E0;\n        border-radius: 5px 5px 0 0;\n      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  } */\n  \n  .chargingTitleChart_Kratos_fleet {\n      font-size: 0.9em;\n      color: #0E3157;\n      /* color: #353535; */\n      font-weight: 600;\n      margin-bottom: 5px;\n      text-align: left;\n      background: #E0E0E0;\n        border-radius: 5px 5px 0 0;\n      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  }\n  \n  \n  /* .secondtable {\n    border-collapse: collapse;\n    width: 100%;\n  } */\n  .secondtable {\n    border-collapse: separate; /* Change from collapse to separate */\n    border-spacing: 0; /* Ensure no spacing between borders */\n    width: 100%;\n    border-radius: 5px; /* Add border radius to the table */\n    overflow: hidden; /* Ensure the corners are rounded */\n    border: 1px solid #46484b; /* Add a border to the table */\n  }\n  \n  .secondtable th, .secondtable td {\n    /* border: 1px solid #ddd; */\n    border: 1px solid #46484b;\n    /* border-radius: 3px solid #46484b; */\n    padding: 8px;\n    text-align: center;\n  }\n  \n  .secondtable th {\n    background-color: #83A4CF;\n    color: #fff;\n    font-size: 13px;\n  }\n  \n  /* .secondtable tbody tr:nth-child(even) {\n    background-color: #f2f2f2;\n  } */\n  \n  /* Add lines after each column */\n  .secondtable th:not(:last-child), .secondtable td:not(:last-child) {\n    /* border-right: 1px solid #ddd; */\n    border-right: 1px solid #46484b;\n  }\n  \n  \n  .chargingChartbox_Kratos{\n      /* background: #FFFFFF;\n      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n      color: #353535;\n      min-height: 280px;\n      border-radius: 5px; */\n    background: #FFFFFF;\n    padding: 0px;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  }\n  \n  .wd_Kratos{\n      min-height: 330px !important;\n  }\n  .wd_4_charts_Kratos{\n      min-height: 307px !important;\n    }\n  .highlightBoxKpi_Kratos{\n      /* min-height: 310px !important; */\n  }\n  .highlightTableSec_Kratos{\n      min-height: 310px !important;\n  }\n  .chargingChartHGT_Kratos{\n      padding: 10px;\n  }\n  \n  .chargingH5_Kratos .h5 {\n      font-size: 1rem !important;\n      /* font-size: 1.1rem !important; */\n  }\n  .chargingKpiSmallTxt_Kratos{\n      font-size: 77% !important;\n      line-height: 1em !important;\n  }\n  \n  .tableContent_Kratos table tr td {\n      font-size:0.8em;\n  }\n  \n  .chargingFilterForm_Kratos > .form-label{\n      font-size:0.825em;\n  }\n  \n  .chargingHeadfont_Kratos{\n      font-size:1.8rem;\n  }\n  .topRightDropMenu_Kratos .dropdown-menu[data-bs-popper] {\n      right:0 !important;\n      left: auto;\n  }\n  \n  /********************  *********************/\n  \n  .contentScroll_Kratos{\n      /* overflow-y: scroll; */\n      /* height:150px; */\n  }\n  \n  .chargingWidget_Kratos p {\n      line-height: 1rem !important;\n  }\n  .chargingWidget_Kratos p small{\n      font-size:80% !important;\n  }\n  \n  /***************************** Toggle Switch ***************************/\n  .toggleBtn_Kratos .form-switch .form-check-input:checked:before {\n      content: \"C\";\n      position: absolute;\n      width: 20px;\n      height: 10px;\n      padding-left: 20px;\n      margin-top: -1px;\n      font-size: 0.7em;\n  }\n  .toggleBtn_Kratos .form-switch .form-check-input:before{\n      content: \"V\";\n      position: absolute;\n      width: 20px;\n      height: 10px;\n      padding-left: 5px;\n      margin-top: -1px;\n      font-size: 0.7em;\n  }\n  .toggleBtn_Kratos .form-switch .form-check-input{\n      color:#83A4CF !important;\n  }\n  \n  /* k */\n  .toggleBtn_Kratos .toggle-button-cover {\n    position: relative;\n    top: 8px;\n  }\n  .dropdownSelectBtnCharging_Kratos{\n      width: fit-content;\n  }\n  .toggleBtn_Kratos .button-cover {\n    background-color: #fff;\n    box-shadow: 0 10px 20px -8px #c5d6d6;\n    border-radius: 4px;\n  }\n  \n  .toggleBtn_Kratos .button-cover:before {\n    color: #d7e3e3;\n    font-size: 12px;\n    line-height: 1;\n    padding: 5px;\n  }\n  \n  .toggleBtn_Kratos .button-cover,\n  .knobs,\n  .layer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  \n  .toggleBtn_Kratos .buttonbtn {\n    position: relative;\n    top: 50%;\n    width: 50px;\n  }\n  \n  .toggleBtn_Kratos .buttonbtn.r,\n  .buttonbtn.r .layer {\n    border-radius: 100px;\n  }\n  \n  .toggleBtn_Kratos .button.b2 {\n    border-radius: 2px;\n  }\n  \n  .toggleBtn_Kratos .checkbox {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 3;\n  }\n  \n  .toggleBtn_Kratos .knobs {\n    z-index: 2;\n  }\n  \n  .toggleBtn_Kratos .layer {\n    width: 100%;\n    background-color: #ebf7fc;\n    transition: 0.3s ease all;\n    z-index: 1;\n  }\n  /* Button 1 */\n  #button-1_Kratos .knobs:before {\n    content: \"V\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 20px;\n    height: 20px;\n    color: #fff;\n    font-size: 10px;\n    font-weight: bold;\n    text-align: center;\n    line-height: 1;\n    padding: 6px 4px;\n    background-color: #83A4CF;\n    border-radius: 50%;\n    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n  }\n  \n  #button-1_Kratos .checkbox:checked + .knobs:before {\n    content: \"C\";\n    left: 30px;\n    background-color: #3578b0;\n  }\n  \n  #button-1_Kratos .checkbox:checked ~ .layer {\n    /* fent orange change */\n    /* background-color: #fcebeb; */\n    background-color: #94c1e6;\n  }\n  \n  #button-1_Kratos .knobs,\n  #button-1_Kratos .knobs:before,\n  #button-1_Kratos .layer {\n    transition: 0.3s ease all;\n  }\n  \n  /***************************** PageTwo *******************************/\n  \n  /*************************  *****************************/\n  .kpiNotificationSlow_Kratos{\n      color: #83A4CF;\n      font-size: 0.7em;\n      font-weight: 500;\n  }\n  .kpiNotificationFast_Kratos{\n      color:#3578b0;\n      font-size:0.7em;\n      font-weight:500;\n  }\n  \n  .kpiNotificationBoth_Kratos{\n      color:#72D817;\n      font-size:0.7em;\n      font-weight:500;\n  }\n  /* media queries start here */\n  \n  @media (min-width: 1440px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  @media (max-width: 1440px) {\n  .highlightTableSec_Kratos{\n      min-height: 310px !important;\n  }\n  }\n  \n  @media (min-width: 1336px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  \n  @media (max-width: 1024px) {\n  .highlightTableSec_Kratos{\n      min-height: 330px !important;\n  }\n  }\n  \n  \n  @media (min-width: 992px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  \n  @media (min-width: 836px) {\n  /* .navbar-expand-sm { */\n      /* flex-wrap: nowrap !important; */\n      /* justify-content: flex-start !important; */\n  /* } */\n  }\n  \n  @media screen and (max-width: 740px) {\n  .chargingTitleBg_Kratos {\n      font-size: 0.9em;\n  }\n  }\n  \n  \n  @media screen and (max-width: 720px) {\n  /* .chargingMainDiv_Bus{ */\n      /* margin-top:124px; */\n  /* } */\n  }\n  \n  @media screen and (max-width: 480px) {\n  /* .chargingMainDiv_Bus{ */\n      /* margin-top:155px; */\n  /* } */\n  }\n      \n  @media screen and (max-width: 480px) {\n  \n  .chargingHeadfont_Kratos {\n      font-size: 1rem;\n  }\n  .chargingTitleBg_Kratos {\n      font-size: 0.9em;\n  }\n  }\n  \n  @media screen and (max-width: 320px) {\n  \n  }\n  \n  .highlight_five_Kratos{\n    margin: auto;\n  }\n  \n  .text_bottom_Kratos{\n    margin-bottom: '-16px !important';\n    display: none;\n    z-index: 1;\n  }\n  .btn-infotable_Kratos:active {\n    color: black;\n    background-color: #fff;\n    border-color: #32879c; \n  }\n  \n  /* .col-19 {\n    flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n  } */\n  \n  @media (min-width: 1440px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  @media (min-width: 1336px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  \n  /* @media (max-width: 576px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 576px) and (max-width: 768px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 768px) and (max-width: 992px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 992px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  } */\n  \n  .main_hole_background{\n    background-color: #F2F3FC;\n    /* height: 530px; */\n    /* min-height: 90vh; \n    display: flex;\n    flex-direction: column; */\n  }\n  \n  .chargingChartboxNew_Kratos {\n    background: #FFFFFF;\n    padding: 0px;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    height: 293px;\n    /* height: 333px; */\n    border-radius: 5px 5px 0 0;\n  }\n  .chargingChartboxNew2_Kratos {\n    background: #FFFFFF;\n    padding: 0px;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    /* height: 293px; */\n    height: 313px;\n    border-radius: 5px 5px 0 0;\n  }\n  \n  .highBold {\n    font-weight: bold;\n    color: black;\n    font-size:16px !important\n  }\n  \n  .filter_kratos_icon_f .rca_btn .rca_btn_kratos  {\n    background-color: #ffa650;\n  }\n  .filter_kratos_icon_f .rca_btn .rca_btn_kratos:hover{\n    background-color: #fcb877 !important; \n    border-color: #fcb877 !important;\n  }\n  \n  .popUpTable{\n    background-color: rgb(131, 164, 207);\n    color: rgb(255, 255, 255);\n    position: sticky;\n    top: 0;\n    z-index: 0;\n  }\n  \n  .custom-table .p-datatable-thead th {\n    background-color: #83A4CF;\n    /* Set your desired background color */\n    color: white;\n    /* Set your desired text color */\n  }\n  \n  /* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */\n  .custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {\n    color: white;\n    height: 20px!important;\n    width: 12px!important;\n    /* Set your desired arrow color */\n  }\n  \n  .even-row {\n    background-color: pink;\n  }\n  \n  .odd-row {\n    background-color: white;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
